<div style="position:absolute; right:0; top:0; padding:20px; z-index:1;">
	<div style="display: flex; align-items: center; justify-content: center;">
		<span *ngIf="allowCancel" (click)="cancel($event)" role="button" class="jmCloseBtn"></span>
	</div>
</div>

<!--this should be modified to show only forms (images shown on signup-login-reset-password.component.html)-->
<div class="componentFormContainer">
	<ng-container *ngIf="steps[currentStep]==='username'">
		<div style="margin-bottom: 10px; margin-top: 20px;">Forgot Password?</div>
		<h1 class="gTextHeadline" [ngClass]="(showMinimize)?'verticalSpacing25btm':'verticalSpacing50btm'">Can't get into your <span class="gColorAccentPrimary">account</span>?</h1>
		<label for="txtUsername" class="form-label">Username or Email</label>
		<input #txtUsername
			   id="txtUsername"
			   type="text"
			   autocomplete="off"
			   autocapitalize="off"
			   class="form-control gFormInput"
			   [ngClass]="(showMinimize)?'verticalSpacing25btm':'verticalSpacing25btm'"
			   maxlength="50"
			   placeholder="Enter Your Email or Username"
			   [(ngModel)]="frmReset.UsernameOrEmail"
			   (keydown)="checkUsername($event)"
			   (blur)="checkUsername($event)" />

		<label for="selZone" class="form-label">Select Zone</label>
		<div style="position: relative;">
			<select id="selZone" #selZone (change)="changeZone($event)" class="form-select gFormInput">
				<option disabled selected hidden value="">Select Zone</option>
				<option *ngIf="frmReset.zonesUpdating" selected value=""></option>
				<ng-container *ngIf="!frmReset.zonesUpdating">
					<option *ngFor="let zone of frmReset.zones" [value]="zone.Client" [selected]="zone.Client===frmReset.Zone">{{zone.DisplayName}}</option>
				</ng-container>
			</select>
			<div *ngIf="frmReset.zonesUpdating" style="position: absolute; top: 10px; left: 10px;"><span class="jmWidgetLoadingIcon20"></span></div>
		</div>

		<div class="message" [ngClass]="(!frmReset.zonesUpdating && frmReset.UsernameOrEmailStatus===false)?'':'hideClickable'">
			Oops. Looks like we don't recognize your information. Please try again. Or contact <a href="mailto:help@journeysmap.com" tabIndex="-1">help&#64;journeysmap.com</a>.
		</div>

		<button ID="btnUsernameNext" #btnUsernameNext type="button" class="btn btn-primary" (click)="checkUsername($event)" [disabled]="!hasUsername()" style="width: 100%;">Next</button>

		<!--<div style="text-align: center; margin-bottom: 20px; margin-top: 10px;">
			If you remember your account now, please <a class="gColorAccentPrimary" role="button" (click)="backToLogin($event)">Log In</a>!
		</div>-->
	</ng-container>

	<ng-container *ngIf="steps[currentStep]==='securityQuestion'">
		<div style="margin-bottom: 10px; margin-top: 20px;">Forgot Password?</div>
		<h1 class="gTextHeadline" [ngClass]="(showMinimize)?'verticalSpacing25btm':'verticalSpacing50btm'">Answer your <span class="gColorAccentPrimary">security</span>questions</h1>

		<div style="margin-top:20px; font-size:16px; text-align:left; margin-bottom: 20px;">
			{{frmReset.SecurityQuestion}}
		</div>

		<div style="display: flex; flex-direction: column;">
			<label for="txtNewPassword" class="form-label">Answer</label>
			<input [(ngModel)]="frmReset.SecurityAnswer"
				   id="txtSecurityAnswer"
				   type="text"
				   autocomplete="off"
				   class="form-control gFormInput"
				   maxlength="500"
				   placeholder="Enter Your Answer Here"
				   (keyup)="checkSecurityAnswer($event)" />
		</div>
		<div class="message" [ngClass]="(!processing && frmReset.SecurityStatus===false)?'':'hideClickable'">
			Sorry! Your answers don't match what we have on file. Please contact <a href="mailto:help@journeysmap.com" tabIndex="-1">help&#64;journeysmap.com</a>.
		</div>

		<div class="loadingSpinnerContainer">
			<div [style.display]="!processing?'':'none'" style="width: 100%;"><button type="button" class="btn btn-primary" (click)="checkSecurityAnswer($event)" style="width: 100%;" [disabled]="!frmReset.SecurityAnswer">Next</button></div>
			<div [style.display]="processing?'':'none'"><span class="jmWidgetLoadingIcon20"></span></div>
		</div>
		<!--<div style="text-align: center; margin-bottom: 20px; margin-top: 10px;">
			If you remember your account now, please <span class="gColorAccentPrimary" role="button" (click)="backToLogin($event)">Log In</span>!
		</div>-->
	</ng-container>

	<ng-container *ngIf="steps[currentStep]==='newPassword'">
		<div style="margin-bottom: 10px; margin-top: 20px;">Reset Password</div>
		<h1 class="gTextHeadline" [ngClass]="(showMinimize)?'verticalSpacing25btm':'verticalSpacing50btm'">Create a new <span class="gColorAccentPrimary">password</span>!</h1>
		
		<div style="position: relative; display: flex; flex-direction: column;">
			<label for="txtNewPassword" class="form-label">Password</label>
			<div style="position: relative;">
				<input [(ngModel)]="frmReset.NewPassword"
					   id="txtNewPassword"
					   type="password"
					   style="width: 100%;"
					   autocomplete="off"
					   [ngClass]="(showMinimize)?'verticalSpacing25btm':'verticalSpacing50btm'"
					   class="form-control gFormInput"
					   maxlength="50"
					   placeholder="Password"
					   (keydown)="checkNewPassword($event)"
					   (focus)="checkNewPassword($event)"
					   (blur)="checkNewPassword($event)" />
				<i tabindex="-1" class="jmActionIcon jmPrimaryForeground inputIcon" [ngClass]="(txtPw1Type === 'password')?'fas fa-eye-slash':'fas fa-eye'" (click)="showPassword('txtNewPassword')"></i>
			</div>
			<div [style.display]="(txtNewPasswordIsFocused)?'':'none'" style="position: absolute; top: 72px; right: 0; width: 70%; z-index: 2;">
				<div style="z-index: 2; width: 0; height: 0; border-left: 8px solid transparent; border-right: 8px solid transparent; border-bottom: 8px solid #28275a; position: absolute; right: 20px; ">
					<div style="width: 0; height: 0; border-left: 8px solid transparent; border-right: 8px solid transparent; border-bottom: 8px solid white; right: -8px; transform: translateY(1px); z-index: 3; position: absolute;">
					</div>
				</div>
				<div style="border-style: solid; border-width: 1px; background-color: white; border-color: #28275a; border-radius: 8px; transform: translateY(8px); padding: 10px;">
					<div style="margin-bottom: 10px; font-weight: bold;">Password <span class="gColorAccentPrimary">Criteria</span></div>
					<ul>
						<li>Must be at least 6 characters</li>
						<li>Include 1 upper case or 1 numeric value</li>
					</ul>
					<!--Password length must be at least 6 characters <br />and <br />include 1 upper case <br />or <br />1 numeric value.-->
				</div>
			</div>
		</div>

		<label for="txtNewPassword2" class="form-label">Re-enter Password</label>
		<div style="position: relative;">
			<input [(ngModel)]="frmReset.NewPassword2"
				   id="txtNewPassword2"
				   style="width: 100%;"
				   type="password"
				   autocomplete="off"
				   class="form-control gFormInput"
				   maxlength="50"
				   placeholder="Re-Type Your Password"
				   (keydown)="checkNewPassword($event)"
				   (focus)="checkNewPassword($event)" />
			<i tabindex="-1" class="jmActionIcon jmPrimaryForeground inputIcon" [ngClass]="(txtPw2Type === 'password')?'fas fa-eye-slash':'fas fa-eye'" (click)="showPassword('txtNewPassword2')"></i>
		</div>
		<div class="message" [style.opacity]="!processing && (frmReset.NewPasswordStatus ===false || frmReset.NewPassword2Status ===false || frmReset.NewPassword !== frmReset.NewPassword2)?'1':'0'">
			Oops. Looks like both passwords not match. Use 1 uppercase letter or 1 number. Please try again.
		</div>

		<div class="loadingSpinnerContainer">
			<div *ngIf="!processing" style="width: 100%;"><button type="button" class="btn btn-primary" (click)="checkNewPassword($event)" style="width: 100%;" [disabled]="frmReset.NewPassword === '' || frmReset.NewPassword2 === ''">Login</button></div>
			<div *ngIf="processing"><span class="jmWidgetLoadingIcon20"></span></div>
		</div>
		<!--<div style="text-align: center; margin-bottom: 20px; margin-top: 10px;">
		If you remember your account now, please <span class="gColorAccentPrimary" role="button" (click)="backToLogin($event)">Log In</span>!
	</div>-->
	</ng-container>

	<ng-container *ngIf="steps[currentStep]==='emailSent'">
		<div style="margin-bottom: 10px; margin-top: 20px;">Reset Password</div>
		<h1 class="gTextHeadline" [ngClass]="(showMinimize)?'verticalSpacing25btm':'verticalSpacing50btm'">Woo-Hoo! Your <span class="gColorAccentPrimary">email</span> has been sent! The link will expire in<span class="gColorAccentPrimary"> 10 minutes</span>!</h1>

		<div class="loadingSpinnerContainer">
			<div *ngIf="!processing" style="width: 100%;"><button type="button" class="btn btn-primary" (click)="backToLogin($event)" style="width: 100%; ">Back To Login</button></div>
			<div *ngIf="processing"><span class="jmWidgetLoadingIcon20"></span></div>
		</div>
	</ng-container>

	<ng-container *ngIf="steps[currentStep]==='resetCode'">
		<div *ngIf="frmReset.ResetCodeStatus === false">
			<h1 class="gTextHeadline" [ngClass]="(showMinimize)?'verticalSpacing25btm':'verticalSpacing50btm'">Womp, Womp. Your <span class="gColorAccentPrimary">code</span> has <span class="gAlertColor">expired</span>.</h1>
			<div class="loadingSpinnerContainer"> 
				<div *ngIf="!processing" style="width: 100%;"><button type="button" class="btn btn-primary" (click)="backToReset($event)" style="width: 100%; ">Re-Enter Email</button></div>
				<div *ngIf="processing"><span class="jmWidgetLoadingIcon20"></span></div>
			</div>
		</div>
	</ng-container>

	<ng-container *ngIf="steps[currentStep]==='resetOption'">
		<div style="margin-bottom: 10px; margin-top: 20px;">Reset Password</div>
		<h1 class="gTextHeadline" [ngClass]="(showMinimize)?'verticalSpacing25btm':'verticalSpacing50btm'">Awesome. Reset your<span class="gColorAccentPrimary"> password</span> with your</h1>
		<div class="loadingSpinnerContainer">
			<div *ngIf="!processing" style="display: flex; flex-direction: row; justify-content: center; align-items: center;">
				<button type="button" class="btn btn-primary" (click)="doOption($event, 'question')" style="width: 150px; margin-right:20px;">Security Question</button>
				<button type="button" class="btn btn-primary" (click)="doOption($event, 'email')" style="width: 150px;">Email</button>
			</div>
			<div *ngIf="processing"><span class="jmWidgetLoadingIcon20"></span></div>
		</div>
		<!--<div class="message">
			If you remember your account now, please <span role="button" (click)="backToLogin($event)" class="text-info">Log In</span>!
		</div>-->
	</ng-container>

	<ng-container *ngIf="steps[currentStep]==='error'">
		<div style="margin-bottom: 10px; margin-top: 20px;">Reset Password</div>
		<h1 class="gTextHeadline" [ngClass]="(showMinimize)?'verticalSpacing25btm':'verticalSpacing50btm'">Oops. Looks like we don't recognize your <span class="gColorAccentPrimary">information</span>.</h1>

		<div *ngIf="resetPWResponse==null">
			Please try again. Or contact <a href="mailto:help@journeysmap.com">help&#64;journeysmap.com</a>.
		</div>

		<div *ngIf="resetPWResponse!=null" class="message">
			<div style="display:none;">
				Error Code: {{resetPWResponse.RecoveryStatusCode}}
			</div>

			<div *ngIf="resetPWResponse.RecoveryStatusCode==='1'">
				Uh-oh! We don't recognize your info. Please contact <a href="mailto:help@journeysmap.com">help&#64;journeysmap.com</a>.
			</div>
			<div *ngIf="resetPWResponse.RecoveryStatusCode==='2'">
				Hmm looks like we found multiple accounts with that information. Please contact <a href="mailto:help@journeysmap.com">help&#64;journeysmap.com</a>.
			</div>
			<div *ngIf="resetPWResponse.RecoveryStatusCode==='3'">
				Sorry, your account has been deemed inactive! Please contact <a href="mailto:help@journeysmap.com">help&#64;journeysmap.com</a>.
			</div>
			<div *ngIf="resetPWResponse.RecoveryStatusCode==='4'">
				Looks like you'll need to chat with support to get into your account! Please contact <a href="mailto:help@journeysmap.com">help&#64;journeysmap.com</a>.
			</div>
			<div *ngIf="resetPWResponse.RecoveryStatusCode==='7'">
				Sorry! Your answers don't match what we have on file. Please contact <a href="mailto:help@journeysmap.com">help&#64;journeysmap.com</a>.
			</div>
			<div *ngIf="resetPWResponse.RecoveryStatusCode==='10'">
				You haven't set up your recovery information! Please contact <a href="mailto:help@journeysmap.com">help&#64;journeysmap.com</a>.
			</div>
		</div>

	</ng-container>

</div>
